/* Larese Store · comportamiento propio (assets/larese.js).
 *
 * Un IIFE sin dependencias, cargado con defer desde snippets/larese-head. Lo
 * primero que hace es poner .lr-js en <html>: los estados ocultos que dependen
 * de este archivo (el WhatsApp flotante) solo existen bajo esa clase, así que
 * sin JS todo se ve. kb-whatsapp la pone antes, con un script en línea, para
 * que el flotante no aparezca mientras este archivo carga. Referencia de
 * comportamiento: la maqueta aprobada
 * (rediseno/final/_build/main.js), adaptada a los componentes de Horizon.
 *
 * a) Scroll. En escritorio Horizon no scrollea la ventana sino .page-wrapper.
 *    Se escucha 'scroll' en document en fase de captura (llega el de cualquier
 *    contenedor, también el de los carruseles) y 'resize', y se mide una vez
 *    por cuadro con requestAnimationFrame. Se mide en cada scroll y no con
 *    IntersectionObserver: un salto de ancla que pasa de arriba a abajo sin
 *    cruzar la pantalla dejaba el estado trabado.
 *
 * b) WhatsApp flotante (#lr-wa, snippets/kb-whatsapp).
 *    CONTRATO: la página marca su ancla con [data-lr-ancla-wa] (el hero de la
 *    portada; .lr-colcab de colección y búsqueda). El botón lleva .is-visible
 *    cuando el borde inferior del ancla ya salió por arriba. Sin ancla está
 *    visible siempre. Se va mientras el renglón final del pie (.lr-pie__base,
 *    sections/larese-pie) pasa por detrás de él: así no tapa "Precios en
 *    guaraníes, IVA incluido" y el pie queda con el relleno de la maqueta, sin
 *    hueco extra abajo. Oculto lleva aria-hidden y tabindex -1. Estilos:
 *    40-pie.css.
 *
 * c) "Agregar" de la tarjeta.
 *    CONTRATO: <a data-lr-agregar href="(la ficha)"> dentro de <product-card>
 *    (snippets/larese-tarjeta). La tarjeta conserva la galería de Horizon,
 *    oculta por CSS, con su <quick-add-component> (snippets/quick-add). Según su
 *    data-quick-add-button:
 *      'add'    -> clic en [ref=addToCartButton] del product-form-component
 *                  (una sola medida: suma directo y abre la bolsa);
 *      'choose' -> clic en .quick-add__button--choose (abre la compra rápida).
 *    Solo si encontró el botón (y no está deshabilitado) se cancela el enlace;
 *    si no, el enlace lleva a la ficha. Con Ctrl, Cmd o Shift se respeta el
 *    enlace (abrir en otra pestaña). Como lleva role="button", la barra
 *    espaciadora también lo activa (un enlace solo responde a Enter).
 *
 * d) Flechas de riel.
 *    CONTRATO: botones [data-lr-riel-dir="-1"|"1"] dentro de .lr-cab, en la
 *    sección inmediatamente anterior al carrusel. Mueven el slideshow-component
 *    de la siguiente .shopify-section hermana que tenga uno (no los de las
 *    tarjetas): next() / previous() de Horizon y, si no existen, scrollBy del
 *    80 % del ancho sobre su [ref=scroller]. La flecha del extremo queda
 *    disabled según el scrollLeft (al cargar y al scrollear el carrusel).
 *
 * e) Bloques vivos.
 *    CONTRATO: [data-lr-vivo="clave"], con claves únicas por sección (la ficha
 *    y la pieza de la casa usan 'consultar' y 'medida'). Al cambiar la medida,
 *    el variant-picker de Horizon dispara 'shopify:product:select' y trae la
 *    sección re-renderizada (event.promise -> detail.html). Cada bloque vivo de
 *    la sección (o del dialog de la compra rápida) se reemplaza por el de la
 *    respuesta. Así kb-consultar y la medida elegida salen siempre del
 *    servidor: acá no se arma ningún texto de WhatsApp. Se ignora el evento de
 *    las tarjetas (product-card).
 *
 * f) Sugerencias del buscador.
 *    CONTRATO: form[data-lr-buscador] con input[name=q][role=combobox] y
 *    #lr-sugerencias[hidden] (la franja de sections/larese-buscador). Desde 2
 *    letras, con 180 ms de espera y cancelando el pedido anterior, pide
 *    search/suggest.json (busca también en la descripción, donde están las
 *    notas, como assets/predictive-search.js) y dibuja hasta 6 filas:
 *      a.lr-sug[role=option] > span.lr-sug__vitrina.lr-vitrina > img
 *                            + span.lr-sug__txt > .lr-sug__marca + .lr-sug__nombre
 *                            + span.lr-sug__precio
 *    Sin resultados: p.lr-sug__vacio con el enlace a WhatsApp. Estilos de .lr-sug*
 *    en 10-cabecera.css. Flechas arriba y abajo mueven .is-activa y
 *    aria-activedescendant; Enter abre la fila activa (si no hay, el formulario
 *    busca); Escape o un clic afuera cierran.
 *
 * g) Bolsa lateral (escritorio): no se reabre sola en cada página y se cierra
 *    con un clic sobre el velo (el velo es el ::after de .page-wrapper,
 *    70-carrito.css).
 *
 * h) Editor de temas: al cargar, sacar o mover una sección se vuelven a
 *    enganchar b, d, f e i.
 *
 * i) Sección actual en la fila del menú (sistema.md §3 "Cabecera").
 *    Horizon pone aria-current="page" solo en la página del enlace
 *    (/collections/perfumes). En lo que está dentro de una sección (la ficha,
 *    Decants, Para ella...) la sección sale de las migas (snippets/larese-migas):
 *    el enlace de primer nivel (#header-component .menu-list__link) que va a la
 *    misma ruta que un tramo de las migas, salvo Inicio, lleva
 *    aria-current="true", como en la maqueta. Mientras se pone lleva .lr-quieto
 *    (10-cabecera.css): el subrayado aparece ya puesto, sin crecer al cargar.
 *
 * El número de WhatsApp (constante WA) también está en kb-whatsapp, larese-pie,
 * kb-consultar, la cabecera y los generadores: si cambia, buscá 972736002 y
 * "972 736 002" en tema/.
 */
(() => {
  const raiz = document.documentElement;
  raiz.classList.add('lr-js');

  const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const WA = '595972736002';
  const WA_CONSULTA = '¡Hola, Larese Store! Tengo una consulta.';

  const esElemento = (x) => x instanceof Element;

  /* a) Scroll: una medida por cuadro ------------------------------------------ */
  const medidas = new Set();
  let cuadro = 0;

  function medir() {
    cuadro = 0;
    medidas.forEach((fn) => fn());
  }

  function pedirMedida() {
    if (!cuadro) cuadro = requestAnimationFrame(medir);
  }

  document.addEventListener('scroll', pedirMedida, { capture: true, passive: true });
  window.addEventListener('resize', pedirMedida, { passive: true });
  window.addEventListener('load', pedirMedida);

  /* b) WhatsApp flotante ------------------------------------------------------- */
  let wa = null;
  let anclaWa = null;
  let baseWa = null;
  let waVisible = null;

  function enlazarWa() {
    wa = document.getElementById('lr-wa');
    anclaWa = document.querySelector('[data-lr-ancla-wa]');
    baseWa = document.querySelector('.lr-pie__base');
    waVisible = null;
    revisarWa();
  }

  // ¿El renglón final del pie pasa por detrás del botón? Se compara con el lugar
  // fijo del botón (alto de la ventana menos su "bottom"), no con su caja: oculto
  // lleva un translate. 8 px de aire arriba.
  function baseDetras() {
    if (!baseWa || !baseWa.isConnected) return false;
    const alto = window.innerHeight;
    const r = baseWa.getBoundingClientRect();
    if (!r.height || r.top >= alto || r.bottom <= 0) return false;
    const abajo = alto - (parseFloat(getComputedStyle(wa).bottom) || 0);
    const arriba = abajo - wa.offsetHeight - 8;
    return r.top < abajo && r.bottom > arriba;
  }

  function revisarWa() {
    if (!wa || !wa.isConnected) return;
    if (anclaWa && !anclaWa.isConnected) anclaWa = document.querySelector('[data-lr-ancla-wa]');
    if (baseWa && !baseWa.isConnected) baseWa = document.querySelector('.lr-pie__base');
    const visible = (anclaWa ? anclaWa.getBoundingClientRect().bottom < 0 : true) && !baseDetras();
    if (visible === waVisible) return;
    waVisible = visible;
    wa.classList.toggle('is-visible', visible);
    if (visible) {
      wa.removeAttribute('aria-hidden');
      wa.removeAttribute('tabindex');
    } else {
      wa.setAttribute('aria-hidden', 'true');
      wa.tabIndex = -1;
    }
  }

  medidas.add(revisarWa);

  /* c) "Agregar" de la tarjeta -------------------------------------------------- */
  document.addEventListener('click', (ev) => {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    const enlace = esElemento(ev.target) ? ev.target.closest('[data-lr-agregar]') : null;
    if (!enlace) return;

    const tarjeta = enlace.closest('product-card');
    const rapida = tarjeta && tarjeta.querySelector('quick-add-component');
    if (!rapida) return;

    let boton = null;
    if (rapida.dataset.quickAddButton === 'add') {
      boton = rapida.querySelector('product-form-component [ref="addToCartButton"]');
    } else if (rapida.dataset.quickAddButton === 'choose') {
      boton = rapida.querySelector('.quick-add__button--choose');
    }
    if (!(boton instanceof HTMLButtonElement) || boton.disabled) return;

    // el componente vive dentro de la foto de Horizon, oculta por CSS: el clic
    // programático igual lo dispara
    ev.preventDefault();
    boton.click();
  });

  // <a role="button">: la barra espaciadora hace lo mismo que el clic (y no
  // baja la página)
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== ' ' || ev.defaultPrevented || ev.repeat || ev.metaKey || ev.ctrlKey || ev.altKey) return;
    const enlace = esElemento(ev.target) ? ev.target.closest('[data-lr-agregar][role="button"]') : null;
    if (!enlace) return;
    ev.preventDefault();
    enlace.click();
  });

  /* d) Flechas de riel --------------------------------------------------------- */
  let rieles = [];

  function slideshowDe(seccion) {
    for (const s of seccion.querySelectorAll('slideshow-component')) {
      if (!s.closest('product-card')) return s;
    }
    return null;
  }

  function carruselDe(boton) {
    const propia = boton.closest('.shopify-section');
    if (!propia) return null;
    for (let s = propia.nextElementSibling; s; s = s.nextElementSibling) {
      if (!s.classList.contains('shopify-section')) continue;
      const show = slideshowDe(s);
      if (show) return show;
      // otra cabeza con flechas: ese carrusel es de ella
      if (s.querySelector('[data-lr-riel-dir]')) return null;
    }
    return null;
  }

  function scrollerDe(show) {
    for (const s of show.querySelectorAll('[ref="scroller"]')) {
      if (s.closest('slideshow-component') === show) return s;
    }
    return null;
  }

  const direccion = (boton) => (Number(boton.dataset.lrRielDir) < 0 ? -1 : 1);

  function deshabilitar(boton, valor) {
    if (boton instanceof HTMLButtonElement) {
      if (boton.disabled !== valor) boton.disabled = valor;
    } else {
      boton.setAttribute('aria-disabled', String(valor));
    }
  }

  function enlazarRieles() {
    rieles = [];
    document.querySelectorAll('[data-lr-riel-dir]').forEach((boton) => {
      const show = carruselDe(boton);
      const scroller = show && scrollerDe(show);
      if (scroller) rieles.push({ boton, scroller });
    });
    medirRieles();
  }

  function medirRieles() {
    rieles.forEach(({ boton, scroller }) => {
      if (!boton.isConnected || !scroller.isConnected) return;
      const x = Math.abs(scroller.scrollLeft);
      const max = scroller.scrollWidth - scroller.clientWidth;
      deshabilitar(boton, direccion(boton) < 0 ? x < 4 : x > max - 4);
    });
  }

  medidas.add(medirRieles);

  document.addEventListener('click', (ev) => {
    const boton = esElemento(ev.target) ? ev.target.closest('[data-lr-riel-dir]') : null;
    if (!boton) return;
    const show = carruselDe(boton);
    if (!show) return;
    ev.preventDefault();

    const dir = direccion(boton);
    const scroller = scrollerDe(show);
    const aMano = () => {
      if (scroller) scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: sinMovimiento ? 'auto' : 'smooth' });
    };

    if (typeof show.next === 'function' && typeof show.previous === 'function') {
      const antes = scroller ? scroller.scrollLeft : 0;
      if (dir > 0) show.next();
      else show.previous();
      // si Horizon no lo movió (un slideshow que no se armó), se mueve a mano
      if (scroller) setTimeout(() => { if (scroller.scrollLeft === antes) aMano(); }, 300);
    } else {
      aMano();
    }
  });

  /* e) Bloques vivos ------------------------------------------------------------ */
  // en captura: llega aunque el evento no burbujee
  document.addEventListener(
    'shopify:product:select',
    (ev) => {
      const origen = ev.target;
      if (!esElemento(origen) || origen.closest('product-card')) return;
      const zona = origen.closest('.shopify-section, dialog');
      if (!zona || !zona.querySelector('[data-lr-vivo]')) return;

      ev.promise
        ?.then((resultado) => {
          const html = resultado && resultado.detail && resultado.detail.html;
          if (!html || typeof html.querySelector !== 'function') return;
          // primero en la misma sección de la respuesta; si no está, en toda
          const propia = zona.id && typeof html.getElementById === 'function' ? html.getElementById(zona.id) : null;

          zona.querySelectorAll('[data-lr-vivo]').forEach((viejo) => {
            if (!viejo.isConnected) return;
            const selector = `[data-lr-vivo="${CSS.escape(viejo.getAttribute('data-lr-vivo') || '')}"]`;
            const nuevo = (propia && propia.querySelector(selector)) || html.querySelector(selector);
            if (nuevo) viejo.replaceWith(document.importNode(nuevo, true));
          });
        })
        .catch(() => {
          /* pedido cancelado por otra medida: lo resuelve el siguiente */
        });
    },
    true
  );

  /* f) Sugerencias del buscador ------------------------------------------------ */
  const buscadoresListos = new WeakSet();

  const miles = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  // "Gs." + espacio duro (escrito como escape para que se vea): el monto no se
  // corta en dos renglones
  const guaranies = (n) => 'Gs.\u00a0' + miles(n);

  // suggest.json trae los precios como texto en guaraníes ("45000.00"); las
  // otras APIs Ajax de Shopify, como número en centavos (4500000)
  function monto(valor) {
    const n = typeof valor === 'number' ? valor / 100 : parseFloat(String(valor == null ? '' : valor));
    return Number.isFinite(n) ? n : null;
  }

  function precioTexto(p) {
    if (p.available === false) return 'Agotado';
    const min = monto(p.price_min != null ? p.price_min : p.price);
    const max = monto(p.price_max != null ? p.price_max : p.price);
    if (min === null) return '';
    return max !== null && max !== min ? `Desde ${guaranies(min)}` : guaranies(min);
  }

  // "Yves Saint Laurent Libre EDP" de Yves Saint Laurent -> "Libre EDP"
  function sinMarca(titulo, marca) {
    const t = String(titulo || '').trim();
    const m = String(marca || '').trim();
    if (m && t.toLowerCase().startsWith(m.toLowerCase() + ' ')) {
      const resto = t.slice(m.length).replace(/^[\s·:-]+/, '');
      if (resto) return resto;
    }
    return t;
  }

  function imagenDe(p) {
    const src = (p.featured_image && p.featured_image.url) || p.image;
    if (!src) return null;
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', '120');
      return url.href;
    } catch (e) {
      return src;
    }
  }

  function nodo(etiqueta, clase, texto) {
    const n = document.createElement(etiqueta);
    if (clase) n.className = clase;
    if (texto != null) n.textContent = texto;
    return n;
  }

  function fila(p, i) {
    const a = nodo('a', 'lr-sug');
    a.href = p.url;
    a.id = `lr-sug-${i}`;
    a.tabIndex = -1;
    a.setAttribute('role', 'option');
    a.setAttribute('aria-selected', 'false');

    const vitrina = nodo('span', 'lr-sug__vitrina lr-vitrina');
    const src = imagenDe(p);
    if (src) {
      const img = nodo('img');
      img.src = src;
      img.width = 120;
      const proporcion = p.featured_image && Number(p.featured_image.aspect_ratio);
      if (proporcion > 0) img.height = Math.round(120 / proporcion);
      img.alt = '';
      img.loading = 'lazy';
      vitrina.append(img);
    }

    const txt = nodo('span', 'lr-sug__txt');
    if (p.vendor) txt.append(nodo('span', 'lr-sug__marca', p.vendor));
    txt.append(nodo('span', 'lr-sug__nombre', sinMarca(p.title, p.vendor)));

    a.append(vitrina, txt, nodo('span', 'lr-sug__precio', precioTexto(p)));
    return a;
  }

  function vacio(q) {
    const p = nodo('p', 'lr-sug__vacio', `No encontramos “${q}”. `);
    const a = nodo('a', 'lr-enlace', 'Preguntanos por WhatsApp.');
    a.href = `https://wa.me/${WA}?text=${encodeURIComponent(WA_CONSULTA)}`;
    a.target = '_blank';
    a.rel = 'noopener';
    p.append(a);
    return p;
  }

  function enlazarBuscador(form) {
    if (buscadoresListos.has(form)) return;
    const campo = form.querySelector('input[name="q"]');
    const lista = form.querySelector('#lr-sugerencias') || document.getElementById('lr-sugerencias');
    if (!campo || !lista) return;
    buscadoresListos.add(form);

    if (!lista.hasAttribute('role')) lista.setAttribute('role', 'listbox');
    if (lista.id && !campo.hasAttribute('aria-controls')) campo.setAttribute('aria-controls', lista.id);
    if (!campo.hasAttribute('aria-autocomplete')) campo.setAttribute('aria-autocomplete', 'list');
    if (!campo.hasAttribute('autocomplete')) campo.setAttribute('autocomplete', 'off');
    campo.setAttribute('aria-expanded', 'false');

    let espera = 0;
    let control = null;
    let filas = [];
    let activa = -1;

    const dentro = (n) => n instanceof Node && (form.contains(n) || lista.contains(n));

    function marcar(i) {
      activa = i;
      filas.forEach((f, k) => {
        f.classList.toggle('is-activa', k === i);
        f.setAttribute('aria-selected', String(k === i));
      });
      if (i >= 0 && filas[i]) {
        campo.setAttribute('aria-activedescendant', filas[i].id);
        filas[i].scrollIntoView({ block: 'nearest' });
      } else {
        campo.removeAttribute('aria-activedescendant');
      }
    }

    function mostrar() {
      lista.hidden = false;
      campo.setAttribute('aria-expanded', 'true');
    }

    function cerrar() {
      lista.hidden = true;
      campo.setAttribute('aria-expanded', 'false');
      marcar(-1);
    }

    function vaciar() {
      filas = [];
      lista.replaceChildren();
      cerrar();
    }

    function pintar(q, productos) {
      filas = productos.slice(0, 6).map(fila);
      activa = -1;
      campo.removeAttribute('aria-activedescendant');
      lista.replaceChildren(...(filas.length ? filas : [vacio(q)]));
      mostrar();
    }

    function pedir(q) {
      if (control) control.abort();
      control = new AbortController();
      const { signal } = control;
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url =
        `${base}search/suggest.json?q=${encodeURIComponent(q)}` +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,vendor,variants.title,tag,body';

      fetch(url, { signal, headers: { Accept: 'application/json' } })
        .then((r) => {
          if (!r.ok) throw new Error(`suggest ${r.status}`);
          return r.json();
        })
        .then((datos) => {
          if (signal.aborted || campo.value.trim() !== q) return;
          const productos = (datos && datos.resources && datos.resources.results && datos.resources.results.products) || [];
          pintar(q, productos);
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          vaciar();
        });
    }

    campo.addEventListener('input', () => {
      clearTimeout(espera);
      const q = campo.value.trim();
      if (q.length < 2) {
        if (control) control.abort();
        vaciar();
        return;
      }
      espera = setTimeout(() => pedir(q), 180);
    });

    campo.addEventListener('focus', () => {
      if (campo.value.trim().length >= 2 && lista.childElementCount) mostrar();
    });

    campo.addEventListener('keydown', (ev) => {
      if (ev.isComposing) return;
      const abierta = !lista.hidden;
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
        if (!filas.length) return;
        ev.preventDefault();
        if (!abierta) mostrar();
        const n = filas.length;
        marcar(ev.key === 'ArrowDown' ? (activa + 1) % n : activa <= 0 ? n - 1 : activa - 1);
      } else if (ev.key === 'Enter') {
        // sin fila activa, el formulario busca como siempre
        if (abierta && activa >= 0 && filas[activa]) {
          ev.preventDefault();
          filas[activa].click();
        }
      } else if (ev.key === 'Escape') {
        if (abierta) {
          ev.preventDefault();
          cerrar();
        }
      }
    });

    // un clic afuera cierra
    document.addEventListener('click', (ev) => {
      if (!lista.hidden && !dentro(ev.target)) cerrar();
    });

    // si el foco se va con Tab a otro control, también
    form.addEventListener('focusout', () => {
      setTimeout(() => {
        const activo = document.activeElement;
        if (!lista.hidden && activo && activo !== document.body && !dentro(activo)) cerrar();
      }, 0);
    });
  }

  function enlazarBuscadores() {
    document.querySelectorAll('form[data-lr-buscador]').forEach(enlazarBuscador);
  }

  /* g) Bolsa lateral ------------------------------------------------------------ */
  function carrito() {
    const cajon = document.getElementById('cart-drawer');
    if (!cajon) return;

    // sin el empuje de la página, no conviene que se reabra solo en cada página
    // (theme-drawer.liquid no guarda los cajones con [no-persist])
    cajon.setAttribute('no-persist', '');
    try {
      const guardados = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(Boolean);
      const resto = guardados.filter((id) => id !== 'cart-drawer');
      if (resto.length !== guardados.length) {
        if (resto.length) sessionStorage.setItem('theme-drawer-open', resto.join(','));
        else sessionStorage.removeItem('theme-drawer-open');
      }
    } catch (e) {
      /* sin sessionStorage no hay nada que limpiar */
    }

    // un clic sobre el velo (el ::after de .page-wrapper) tiene como destino
    // .page-wrapper; el cajón vive fuera de .page-wrapper
    document.addEventListener('click', (ev) => {
      const t = ev.target;
      if (
        t instanceof Element &&
        t.classList.contains('page-wrapper--drawer-open') &&
        cajon.hasAttribute('open') &&
        typeof cajon.close === 'function'
      ) {
        cajon.close();
      }
    });
  }

  /* i) Sección actual en el menú ------------------------------------------------ */
  function rutaDe(href) {
    try {
      return new URL(href, window.location.href).pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return '';
    }
  }

  function marcarSeccion() {
    const tramos = Array.from(document.querySelectorAll('.lr-migas a[href]')).slice(1); // sin Inicio
    if (!tramos.length) return;
    const rutas = new Set(tramos.map((a) => rutaDe(a.getAttribute('href'))));
    document.querySelectorAll('#header-component .menu-list__link[href]').forEach((enlace) => {
      if (enlace.hasAttribute('aria-current') || !rutas.has(rutaDe(enlace.getAttribute('href')))) return;
      enlace.classList.add('lr-quieto');
      enlace.setAttribute('aria-current', 'true');
      void enlace.offsetWidth; // el estilo se aplica acá, sin transición
      enlace.classList.remove('lr-quieto');
    });
  }

  /* Arranque y h) editor de temas ---------------------------------------------- */
  function enganchar() {
    enlazarWa();
    enlazarRieles();
    enlazarBuscadores();
    marcarSeccion();
  }

  function iniciar() {
    enganchar();
    carrito();
  }

  // con defer el documento ya está armado: se engancha en la misma tarea en que
  // se pone .lr-js, así el flotante no parpadea
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((tipo) => {
    document.addEventListener(tipo, () => setTimeout(enganchar, 0));
  });
})();
